import { LoadingScreen } from "@/components/LoadingScreen";
import { Button } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";
import { useHandleSignInCallback } from "@logto/react";
import { useNavigate } from "react-router-dom";

export function LoginCallback() {
  const navigate = useNavigate();

  const { isLoading, error } = useHandleSignInCallback(() => {
    const redirectUrl = sessionStorage.getItem("redirectUrl") ?? "/";
    sessionStorage.removeItem("redirectUrl");

    navigate(redirectUrl, { replace: true });
  });

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (error) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-white">
        <Card>
          <div className="flex flex-col space-y-2">
            <p className="text-center text-xl font-bold">
              Bei der Anmeldung ist ein Fehler aufgetreten.
            </p>
            <pre className="overflow-x-auto rounded-md bg-gray-300 p-2 text-sm">
              {error.message}
            </pre>
            <Button
              onClick={() => {
                window.location.href = "/";
              }}
              size="lg"
              variant="default"
            >
              Erneut versuchen
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  return <LoadingScreen />;
}
